import React from 'react';
import { useNavigate } from 'react-router-dom';
import { East } from '@mui/icons-material';
import './SharedPostLink.css';

const SharedPostLink = ({ postId, caption, senderName }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        // Navigate to the post with the postId
        navigate(`/myjoynet?post=${postId}`);
    };

    return (
        <div className="shared-post-link" onClick={handleClick}>
            <div className="shared-post-content">
                <div className="shared-post-header">
                    <span className="sender-name">{senderName}</span>
                    <span className="shared-label">shared a post</span>
                </div>
                <div className="post-caption">{caption}</div>
                <div className="click-to-view">Click to view post <East sx={{ fontSize: 14, verticalAlign: 'middle', ml: 0.5 }} /></div>
            </div>
        </div>
    );
};

export default SharedPostLink; 